export default {
  functional: true,
  render (h, context) {
    const {
      popoverConfig
    } = context.props
    const { renderCardName, reference, ...popoverProps } = popoverConfig || {}
    const attrs = {
      props: {
        ...popoverProps,
        popperClass: 'kye-report-popover-class', // 公共class 跟随question组件
        trigger: 'hover', // 只能hover，不接受其他场景
        reference
      }
    }
    const { default: defaultVnode = [] } = context.slots() || {}
    const [childen] = defaultVnode
    const { content } = attrs.props
    // 只有内容存在（插槽或者content属性） 才会渲染
    const showPopover = renderCardName && (content || childen)
    return (<div style="position: absolute">
      {
        showPopover ? <el-popover
          ref="popover"
          key={renderCardName}
          {...attrs}
        >
          {
            childen
          }
        </el-popover> : null
      }
    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/card/common/popover.js